import { Radio, RadioGroup, SelectBox } from "components/uikit-adapter";
import { gridParameterizationType } from "pages/master-data/unit-management/grid-parameterization/utils";
import { useState } from "react";
import intl from "react-intl-universal";
import type { IOption } from "types/option";
import { useGridParameterizationContext } from "../../../../context";
import { SelectBoxWrapper } from "../../styled";
import SelectableAndSearchableList from "../selectable-and-searchable-list";

const UnloadCapacityFilter = () => {
  const {
    businessUnits,
    materialGroups,
    families,
    selectedRadioUnloadCapacity,
    setSelectedRadioUnloadCapacity,
    filtersUnloadCapacity,
    handleChangeFilter,
  } = useGridParameterizationContext();
  const [radioValues, setRadioValues] = useState({
    materialGroup: {
      name: intl.get("commons.materialGroup"),
      value: "materialGroup",
      checked: selectedRadioUnloadCapacity === "materialGroup"
    },
    family: {
      name: intl.get("commons.family"),
      value: "family",
      checked: selectedRadioUnloadCapacity === "family"
    }
  });
  

  const handleRadioClick = (value: string) => {
    setRadioValues((prevState) => ({
      materialGroup: {
        ...prevState.materialGroup,
        checked: prevState.materialGroup.value === value,
      },
      family: {
        ...prevState.family,
        checked: prevState.family.value === value,
      },
    }));

    setSelectedRadioUnloadCapacity(value);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <SelectBoxWrapper>
        <SelectBox
          label={intl.get("commons.businessUnit")}
          placeholder={intl.get("commons.businessUnit")}
          valueKey="Id"
          labelKey="Description"
          options={businessUnits}
          onChange={(value: IOption) =>
            handleChangeFilter(gridParameterizationType.UnloadCapacity, "businessUnitId", value.Id)
          }
          name={"business-unit"}
          value={filtersUnloadCapacity.businessUnitId}
          required
        />
      </SelectBoxWrapper>

      <RadioGroup name={""} label={""} style={{ paddingTop: "8px", marginBottom: "-8px" }}>
        <Radio
          checked={radioValues.materialGroup.checked}
          text={radioValues.materialGroup.name}
          value={radioValues.materialGroup.value}
          onChange={(ev) => handleRadioClick(ev.target.value)}
        />
        <Radio
          checked={radioValues.family.checked}
          text={radioValues.family.name}
          value={radioValues.family.value}
          onChange={(ev) => handleRadioClick(ev.target.value)}
        />
      </RadioGroup>

      {selectedRadioUnloadCapacity === "materialGroup" && (
        <SelectableAndSearchableList
          type={gridParameterizationType.UnloadCapacity}
          prop={"materialGroupId"}
          data={materialGroups}
          filters={filtersUnloadCapacity}
        />
      )}

      {selectedRadioUnloadCapacity === "family" && (
        <SelectableAndSearchableList
          type={gridParameterizationType.UnloadCapacity}
          prop={"familyId"}
          data={families}
          filters={filtersUnloadCapacity}
        />
      )}
    </div>
  );
};

export default UnloadCapacityFilter;
